import { DEFAULT_PAGE_SIZE } from "@/const";
import {
  GridFilterItem,
  GridPaginationModel,
  GridSortModel,
} from "@mui/x-data-grid";
import { create } from "zustand";

type StoriesDatagridState = {
  paginationModel: GridPaginationModel;
  sortModel: GridSortModel;
  selectedIds: string[];
  filterItems: GridFilterItem[];
};

type StoriesDatagridActions = {
  setPaginationModel: (model: GridPaginationModel) => void;
  setSortModel: (model: GridSortModel) => void;
  setSelectedIds: (ids: string[]) => void;
  setFilterItems: (items: GridFilterItem[]) => void;
};

export const useStoriesDatagridStore = create<
  StoriesDatagridState & StoriesDatagridActions
>((set) => ({
  paginationModel: { page: 0, pageSize: DEFAULT_PAGE_SIZE },
  sortModel: [],
  selectedIds: [],
  filterItems: [],
  setPaginationModel: (model) => set({ paginationModel: model }),
  setSortModel: (model) => set({ sortModel: model }),
  setSelectedIds: (ids) => set({ selectedIds: ids }),
  setFilterItems: (items) => set({ filterItems: items }),
}));
